import { SortingState } from '@tanstack/react-table';

export const mapReactTableSortToApiSort = (sortItems: SortingState) => {
  return sortItems.map((sortItem) => {
    return `${sortItem.id}.${sortItem.desc ? 'desc' : 'asc'}`;
  });
};
